import { createAction } from '@reduxjs/toolkit';

export const clearParkingAndReservation = createAction(
  'parkingAndReservations/clearParkingAndReservation',
);
